import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPostoMacroPosto } from '../../services/macro-posto-services.service';

@Component({
  selector: 'app-macro-posto-select',
  templateUrl: './macro-posto.component.html',
  styleUrls: ['./macro-posto.component.scss'],
})
export class MacroPostoComponent implements OnInit {
  @Input() postosMacroPosto: IPostoMacroPosto[] = [];

  @Output() postoSelecionado = new EventEmitter<IPostoMacroPosto>();

  filteredPostos: IPostoMacroPosto[] = [];
  searchTerm: string = '';
  selectedCodPosto: IPostoMacroPosto | null = null;

  ngOnInit(): void {
    this.filteredPostos = this.postosMacroPosto;
    console.log(this.postosMacroPosto);
  }

  onSearchChange(term: string) {
    if (term.length > 0) {
      this.searchTerm = term;
      const lower = term.toLowerCase();

      console.log('Filtering postos with term:', lower);

      this.filteredPostos = this.postosMacroPosto.filter((p) =>
        `${p.codPosto} - ${p.nomePosto}`.toLowerCase().includes(lower)
      );

      console.log(this.filteredPostos);

      this.selectedCodPosto =
        this.filteredPostos.length > 0 ? this.filteredPostos[0] : null;
      if (this.selectedCodPosto !== null)
        this.postoSelecionado.emit(this.selectedCodPosto);
    } else {
      this.filteredPostos = this.postosMacroPosto;
    }
  }

  onSelectChange(codPosto: IPostoMacroPosto) {
    this.selectedCodPosto = codPosto;
    console.log('Selected posto changed to:', this.selectedCodPosto);
    // if (this.selectedCodPosto !== null)
    //   this.postoSelecionado.emit(this.selectedCodPosto);
  }

  enviarPostoSelecionado() {
    if (this.selectedCodPosto !== null) {
      this.postoSelecionado.emit(this.selectedCodPosto);
    }
  }
}
